package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GENERATE_MERCHANT_PHONE_VERIFICATION_CODE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GenerateMerchantPhoneVerificationCodeRequestModel(
    val dialCode: String,
    val phoneNumber: String,
) : BaseRequestModel(api = GENERATE_MERCHANT_PHONE_VERIFICATION_CODE)
